import { Col, Drawer, Flex, Form, message, Row, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useToken } from "../../common/helper/index.js";
import {
  AddItemButton,
  CustomModalWithoutButton,
  CustomParagraph,
  CustomTitle,
} from "../../components/index.js";
import { useSpin } from "../../components/SpinContext.js";
import CommonDrawer from "../../components/CommonDrawer.jsx";
import { Select, Table } from "antd";
import { AssignPermissionOptions } from "../../common/static_data";
import AddNewRoleForm from "../Modals/AddNewRoleForm.jsx";
import { EditOutlined, InfoCircleOutlined } from "@ant-design/icons";
import EditIcon from "../../assets/images/edit-icon.svg";
import { ChangeRolePermission, GetRoles } from "../../api's/roles.js";
import { useSelector } from "react-redux";
import { getPermissions } from "../../common/helper/getPermissions.js";
import { useDispatch } from "react-redux";
import { fetchMenu } from "../../reudx-toolkit/slice/menuSlice.js";
const arr = [
  {
    id: 0,
    role: "Admin",
    featurelis: [
      { featureName: "Home", permission: ["Create"] },
      { featureName: "Control tower", permission: ["Create"] },
      { featureName: "Airport", permission: ["Create"] },
      { featureName: "Notifications", permission: ["Create", "edit"] },
      { featureName: "Transport providers", permission: ["Create"] },
      { featureName: "Products", permission: ["Create"] },
      { featureName: "Sensors", permission: ["Create", "No_Access"] },
      { featureName: "Locations", permission: ["Create"] },
      { featureName: "Teams", permission: ["Create", "edit"] },
      { featureName: "Users", permission: ["Create"] },
      { featureName: "Roles & Permissions", permission: ["Create"] },
      { featureName: "AI", permission: ["Create", "edit"] },
    ],
  },
  {
    id: 1,
    role: "Member",
    featurelis: [
      { featureName: "Home", permission: ["Create"] },
      { featureName: "Control tower", permission: ["Create"] },
      { featureName: "Airport", permission: ["Edit"] },
      { featureName: "Notifications", permission: ["Edit"] },
      { featureName: "Transport providers", permission: ["View"] },
      { featureName: "Products", permission: ["View"] },
      { featureName: "Sensors", permission: ["View"] },
      { featureName: "Locations", permission: ["Edit"] },
      { featureName: "Teams", permission: ["No access"] },
      { featureName: "Users", permission: ["No access"] },
      { featureName: "Roles & Permissions", permission: ["No access"] },
      { featureName: "AI", permission: ["No access"] },
    ],
  },
  {
    id: 2,
    role: "Viewer",
    featurelis: [
      { featureName: "Home", permission: ["View"] },
      { featureName: "Control tower", permission: ["View"] },
      { featureName: "Airport", permission: ["View"] },
      { featureName: "Notifications", permission: ["Create (Self)"] },
      { featureName: "Transport providers", permission: ["No access"] },
      { featureName: "Products", permission: ["No access"] },
      { featureName: "Sensors", permission: ["No access"] },
      { featureName: "Locations", permission: ["No access"] },
      { featureName: "Teams", permission: ["No access"] },
      { featureName: "Users", permission: ["No access"] },
      { featureName: "Roles & Permissions", permission: ["No access"] },
      { featureName: "AI", permission: ["No access"] },
    ],
  },

  {
    id: 3,
    role: "Driver",
    featurelis: [
      { featureName: "Home", permission: ["View"] },
      { featureName: "Control tower", permission: ["View"] },
      { featureName: "Airport", permission: ["View"] },
      { featureName: "Notifications", permission: ["Create (Self)"] },
      { featureName: "Transport providers", permission: ["No access"] },
      { featureName: "Products", permission: ["No access"] },
      { featureName: "Sensors", permission: ["No access"] },
      { featureName: "Locations", permission: ["No access"] },
      { featureName: "Teams", permission: ["No access"] },
      { featureName: "Users", permission: ["No access"] },
      { featureName: "Roles & Permissions", permission: ["No access"] },
      { featureName: "AI", permission: ["No access"] },
    ],
  },
];

const RolesAndPermissions = () => {
  const [infoDrawerOpen, setInfoDrawerOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 991);
  const main_menu = useSelector((state) => state.menu.items);
  const RolesPermissions = getPermissions(main_menu, "Settings", "Roles & Permissions");
 const dispatch = useDispatch();

  // Detect screen size changes
  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 1024);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const [form] = Form.useForm();
  const { showSpin, hideSpin } = useSpin();
  const { token, removeToken } = useToken();
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [permissionOptions, setPermissionOptions] = useState(
    AssignPermissionOptions
  );
  const [selectedRoleData, setSelectedRoleData] = useState("");
  const [roleList, setRoleList] = useState([]);
  const [featureName, setFeatureName] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  const [permissions, setPermissions] = useState({});
  const fetchAllRoles = () => {
    showSpin();
    GetRoles(token)
      .then((res) => {
        const data = res?.data ? res.data : null;
        if (data) {
          if (data?.data?.is_success) {
            let arr = data?.data?.data.length > 0 ? data?.data?.data : [];
            if (arr.length > 0) {
              setRoleList(arr);
              // setFeatureName(createFeatureNameList(arr))
            }
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };

  const unauthorize = (error) => {
    if (error && error?.status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  useEffect(() => {
    setRoleList([]);
    fetchAllRoles();
  }, []);

  useEffect(() => {
    if (roleList?.length > 0) {
      let x = [];
      roleList.forEach((element, index) => {
        if (element && element?.feature_list) {
          x = element?.feature_list.map((f) => f.feature_name);
          setFeatureName(x);
          // console.log(x)
        }
      });
      // const featureNames = [
      //   ...new Set(
      //     roleList?.flatMap((role) => {
      //       }
      //     )
      //   ),
      // ];
      // console.log(x);
      const dataS = x.map((feature_name) => {
        const row = { key: feature_name, feature_name };
        roleList?.forEach(({ name, featurelist }) => {
          const feature = featurelist?.find(
            (f) => f.feature_name === feature_name
          );
          row[name] = feature ? feature?.permission[0] : "No access";
        });
        return row;
      });
      // console.log(dataS);
      setPermissions(() => {
        const initialState = {};
        roleList.forEach((role) => {
          role?.feature_list?.forEach((feature) => {
            initialState[`${feature?.feature_name}-${role?.name}`] =
              feature.permission[0];
          });
        });
        return initialState;
      });

      setDataSource(dataS);
    }
  }, [roleList]);

  const handleCloseDrawer = () => {
    form.resetFields();
    setSelectedRoleData(null);
    setDrawerOpen(false);
  };

  // ==================================== [mahtab notificaiton ]

  //  const createFeatureNameList = (roles)=>{
  //   return new Set(
  //     roles?.flatMap((role) => role?.featurelis?.map((f) => f?.featureName))
  //   )
  //  }
  const { Option } = Select;
  // const featureNames = [

  //   ...new Set(
  //     roleList?.flatMap((role) => role?.featurelis?.map((f) => f?.featureName))
  //   ),
  // ];

  // const [permissions, setPermissions] = useState(() => {
  //   const initialState = {};
  //   roleList.forEach((role) => {
  //     role.featurelist.forEach((feature) => {
  //       initialState[`${feature.feature_name}-${role.name}`] =
  //         feature.permission[0];
  //     });
  //   });
  //   return initialState;
  // });

  const handleChange = (featureName, role, value, rec) => {
    let model = rec;
    let u = model?.feature_list?.find((x) => x.feature_name === featureName);
    u.permission[0] = value;
    ChangeRolePermission(token, model)
      .then((res) => {
        const data = res?.data || null;
        if (data) {
          if (data?.data?.is_success) {
            fetchAllRoles();
            dispatch(fetchMenu(token))
            message.success(data?.data?.message);
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((err) => {
        unauthorize(err);
      })
      .finally(() => {
        hideSpin();
      });
    // setPermissions((prev) => ({
    //   ...prev,
    //   [`${featureName}-${role}`]: value,
    // }));
  };

  const handleEditRole = (id, role, is_connected_with_anything) => {
    setSelectedRoleData({
      id: id,
      name: role,
      is_connected_with_anything: is_connected_with_anything,
      is_delete: RolesPermissions?.is_delete,
    });
    setDrawerOpen(true);
  };

  const columns = [
    {
      title: "",
      dataIndex: "feature_name",
      key: "feature_name",
    },
    ...roleList.map((role, index) => ({
      // title: role,
      dataIndex: role?.id,
      key: role?.id,
      title: (
        <div style={{ display: "flex", alignItems: "center" }}>
          {role?.name}
          {index >= 3 && RolesPermissions?.is_update ? (
            <Tooltip title={`Edit ${role?.name}`}>
              <img
                src={EditIcon}
                style={{
                  height: "12px",
                  marginLeft: 8,
                  cursor: "pointer",
                  color: "#1890ff",
                }}
                onClick={() =>
                  handleEditRole(
                    role?.id,
                    role?.name, 
                    role?.is_connected_with_anything, 
                  )
                }
              />
            </Tooltip>
          ) :  null}
        </div>
      ),
      render: (value, record) => {
        const filteredOptions =
        record.feature_name === "Notifications"
          ? permissionOptions
          : record.feature_name === "Teams"
          ? permissionOptions.filter(item => item.value === "VIEW" || item.value === "NO_ACCESS")
          : permissionOptions.filter(item => item.value !== "Create_self");
        
          const isDisabled =
            (role?.name?.toLowerCase() === "admin" || role?.name?.toLowerCase() === "member" || role?.name?.toLowerCase() === "viewer");
          
          return (
            <div style={{ display: "flex", alignItems: "center", cursor: isDisabled ? "not-allowed" : "pointer", }}>
              <Select
                style={{
                  width: "100%",
                  backgroundColor: '#f3f3f3',
                  border:  "1px solid transparent",
                  fontSize: "12px",
                  borderRadius: "8px",
                  pointerEvents: isDisabled ? "none" : "auto",
                  cursor: isDisabled ? "not-allowed" : "pointer",
                }}
                value={permissions[`${record.feature_name}-${role?.name}`]}
                onChange={(val) => handleChange(record.feature_name, role?.name, val, role)}
              >
                {filteredOptions.map((item) => (
                  <Option key={item.value} value={item.value}>
                    {item.label}
                  </Option>
                ))}
              </Select>
            </div>
          );
        
      },
    })),
  ];

  // const dataSource = featureName.map((featureName) => {
  //   const row = { key: featureName, featureName };
  //   roleList?.forEach(({ role, featurelis }) => {
  //     const feature = featurelis?.find((f) => f.featureName === featureName);
  //     row[role] = feature ? feature?.permission[0] : "No access";
  //   });
  //   return row;
  // });

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col
          xl={18}
          lg={16}
          md={24}
          sm={24}
          xs={24}
          className="col-md-order-1 col-sm-order-2"
        >
          <Flex justify="space-between" align="center" style={{marginBottom: "16px"}}>
            <CustomTitle
              text={` Roles (${roleList?.length})`}
              fontSize={20}
              fontWeight="700"
              lineHeight="28px"
              color="#000"
              marginBottom="0"
            />
            {!isDesktop && (
              <InfoCircleOutlined
                className="zl-custom-icon"
                style={{ cursor: "pointer" }}
                onClick={() => setInfoDrawerOpen(true)}
              />
            )}
          </Flex>

          <div className="p-6">
            <Table
              columns={columns}
              dataSource={dataSource}
              pagination={false}
              className="custom-table custom-roles-table w-full"
              rowHoverable={false}
              scroll={{ x: "max-content" }}
            />

            {/* add more Button */}
          {RolesPermissions?.is_create &&  
          <div style={{ marginTop: "24px" }}>
              <AddItemButton
                fontSize="12px"
                fontWeight="600"
                text={"Add role"}
                onClick={() => {
                  setDrawerOpen(true);
                }}
              />
            </div>}
          </div>
          <CommonDrawer open={drawerOpen} onClose={() => handleCloseDrawer()}>
            <AddNewRoleForm
              onClose={() => handleCloseDrawer()}
              modalOpen={drawerOpen}
              setModalOpen={setDrawerOpen}
              editData={selectedRoleData}
              form={form}
              fetchAllRoles={fetchAllRoles}
            />
          </CommonDrawer>
        </Col>
        <Col
          xl={6}
          lg={8}
          md={24}
          sm={24}
          xs={24}
          className="col-md-order-2 col-sm-order-1"
        >
          <div className="RolesAndPermissionsCard">
            <CustomParagraph
              text={"Give access via Roles"}
              fontSize={20}
              fontWeight={700}
              lineHeight="28px"
              color="#000"
              marginBottom="16px"
            />
            <p>ZoomLogi has 3 initial roles: Admin, Member & Viewer.</p>
            <p>
              The <b> View</b> permission allows users to view the relevant
              piece of content. <b> Edit</b> allows users to edit that
              information (plus View). The <b> Create </b> option allows users
              to add new content (plus Edit and View) in that area.
            </p>
            <p>
              {" "}
              <b> No access </b> bars access from that content.
            </p>
          </div>
        </Col>
        <Drawer
        className="roles-permission-drawer"
          title="Roles & Permissions"
          placement="right"
          open={infoDrawerOpen}
          onClose={() => setInfoDrawerOpen(false)}
        >
          <div className="RolesAndPermissionsCard RolesAndPermissions-mobile-card ">
            <CustomParagraph
              text={"Give access via Roles"}
              fontSize={20}
              fontWeight={700}
              lineHeight="28px"
              color="#000"
              marginBottom="16px"
            />
            <p>ZoomLogi has 3 initial roles: Admin, Member & Viewer.</p>
            <p>
              The <b>View</b> permission allows users to view the relevant piece
              of content. <b>Edit</b> allows users to edit that information
              (plus View). The <b>Create</b> option allows users to add new
              content (plus Edit and View) in that area.
            </p>
            <p>
              <b>No access</b> bars access from that content.
            </p>
          </div>
        </Drawer>
      </Row>
    </>
  );
};

export default RolesAndPermissions;
